var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: 4
  }, /*#__PURE__*/React.createElement("circle", {
    id: "BG",
    cx: 14.0987,
    cy: 13.5855,
    r: 13.5855,
    fill: "#F9F9F7",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("g", {
    id: "logo-github 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.706 7.01611C11.2214 7.01611 8.41797 9.81954 8.41797 13.3042C8.41797 16.0814 10.2258 18.4394 12.7148 19.2778C13.0292 19.3302 13.134 19.1468 13.134 18.9634C13.134 18.8062 13.134 18.4132 13.134 17.8892C11.3786 18.2822 11.0118 17.0508 11.0118 17.0508C10.7236 16.3172 10.3044 16.1338 10.3044 16.1338C9.72798 15.7408 10.3568 15.7408 10.3568 15.7408C10.9856 15.7932 11.3262 16.3958 11.3262 16.3958C11.8764 17.3652 12.7934 17.077 13.1602 16.9198C13.2126 16.5006 13.3698 16.2386 13.5532 16.0814C12.1646 15.9242 10.6974 15.374 10.6974 12.9636C10.6974 12.2824 10.9332 11.706 11.3524 11.2868C11.3 11.1295 11.0642 10.5007 11.4048 9.60994C11.4048 9.60994 11.9288 9.45273 13.134 10.2649C13.6318 10.1339 14.182 10.0553 14.706 10.0553C15.23 10.0553 15.7802 10.1339 16.278 10.2649C17.4833 9.45273 18.0073 9.60994 18.0073 9.60994C18.3479 10.4745 18.1383 11.1033 18.0597 11.2868C18.4527 11.7322 18.7147 12.2824 18.7147 12.9636C18.7147 15.374 17.2474 15.898 15.8326 16.0552C16.0684 16.2386 16.2518 16.6316 16.2518 17.208C16.2518 18.0464 16.2518 18.7276 16.2518 18.9372C16.2518 19.0944 16.3566 19.304 16.6972 19.2516C19.1863 18.4394 20.9941 16.0814 20.9941 13.3042C20.9941 9.81954 18.1907 7.01611 14.706 7.01611Z",
    fill: "white"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.6f96089ec57f9426290dff7453c53074.svg";
export { ForwardRef as ReactComponent };